import type { GetApiV1CourseregistrationEnrollmentGridQueryParams } from '@/shared/api/generated';

import type { EnrollmentFilters } from '../types/enrollment';
import { ENROLLMENT_STATUS_TO_CODE } from '../types/enrollmentStatusCode';

function documentationFilterToEnum(filter: EnrollmentFilters['documentationFilter']): 0 | 1 | 2 {
  if (filter === 'with_documents') return 1;
  if (filter === 'without_documents') return 2;
  return 0;
}

/**
 * Converte o estado dos filtros Jotai do grid de matrículas no shape esperado
 * pelo endpoint GET /api/v1/courseregistration/enrollment/grid.
 *
 * Strings vazias são omitidas do objeto retornado (sem filtro). O array
 * `statuses` é colapsado no primeiro elemento porque o endpoint aceita apenas
 * um Status.
 *
 * @param filters - Estado atual do atom `enrollmentFiltersAtom`
 * @param page - Página solicitada (1-based)
 * @param pageSize - Tamanho da página
 */
export function mapEnrollmentFiltersToParams(
  filters: EnrollmentFilters,
  page: number,
  pageSize: number,
): GetApiV1CourseregistrationEnrollmentGridQueryParams {
  const params: GetApiV1CourseregistrationEnrollmentGridQueryParams = {
    Documents: documentationFilterToEnum(filters.documentationFilter),
    Page: page,
    PageSize: pageSize,
  };

  if (filters.cpf.trim() !== '') params.Cpf = filters.cpf;
  if (filters.email.trim() !== '') params.Email = filters.email;
  if (filters.studentName.trim() !== '') params.StudentName = filters.studentName;
  if (filters.courseId.trim() !== '') params.CourseNames = filters.courseId;
  if (filters.polo.trim() !== '') params.PoleId = Number(filters.polo);

  const firstStatus = filters.statuses[0];
  if (firstStatus) params.Status = ENROLLMENT_STATUS_TO_CODE[firstStatus];

  if (filters.documentStartDate.trim() !== '') {
    params.DocumentStartDate = filters.documentStartDate;
  }
  if (filters.documentEndDate.trim() !== '') {
    params.DocumentEndDate = filters.documentEndDate;
  }

  return params;
}
